import { render } from "./Classes.vue?vue&type=template&id=97727fd0"
import script from "./Classes.vue?vue&type=script&lang=js"
export * from "./Classes.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\Projects\\Web\\era-old.proj\\era.alpha-23-24.local\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.8_vue@3.3.8_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__